import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { OfflineStorageTimestampService } from '../../../offline-storage-timestamp.service';
import { AbstractOfflineStorageService } from '../../abstract/abstract-offline-storage-service';
import { ExpiredTaskChangesRemover } from './expired-task-changes-remover';
import { OfflineTaskChangesObject } from './offline-task-changes-object';
import { cloneDeep } from 'lodash';
import * as moment from 'moment-timezone';
import DateHelper from 'src/app/helpers/date-helper';

@Injectable({
  providedIn: 'root',
})
export class PlacerTaskChangesService extends AbstractOfflineStorageService<
  number,
  OfflineTaskChangesObject,
  ExpiredTaskChangesRemover
> {
  constructor(
    protected offlineStorageTimestampService: OfflineStorageTimestampService,
    protected ngForage: NgForage
  ) {
    super('task-', 'tasks', offlineStorageTimestampService, ngForage);
  }

  // Override
  protected instantiateRemover(): ExpiredTaskChangesRemover {
    return new ExpiredTaskChangesRemover(
      this,
      this.offlineStorageTimestampService,
      this.ngForage
    );
  }

  public override cleanupOfflineObject(
    object: OfflineTaskChangesObject
  ): Promise<void> {
    throw new Error('Method not implemented.');
  }

  protected override processRetrievedObject(
    object: OfflineTaskChangesObject
  ): OfflineTaskChangesObject {
    if (
      object != null &&
      CollectionHelper.isPopulated(object.registeredActions)
    ) {
      object.registeredActions.forEach(
        (r) =>
          (r.actualDate =
            r.date == null
              ? null
              : moment.tz(r.date, DateHelper.DEFAULT_TIME_ZONE))
      );
    }
    return object;
  }

  protected override verifyToStoreObject(
    object: OfflineTaskChangesObject
  ): void {
    if (object == null || object.id == null) {
      throw new Error(
        'offlineTaskChangesObject must not be null and id must not be null'
      );
    }
  }

  protected override preprocessToStoreObject(
    object: OfflineTaskChangesObject
  ): OfflineTaskChangesObject {
    const toReturn = cloneDeep(object);
    if (CollectionHelper.isPopulated(toReturn.registeredActions)) {
      toReturn.registeredActions.forEach((r) => delete r.actualDate); // IndexedDB cannot store functions, which is a problem for Moments
    }
    return toReturn;
  }

  public override convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected override stringifyID(id: number): string {
    return id.toString();
  }
}
